import React from 'react'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import MediaQuery from 'react-responsive';

import { Information, Experience, Projects, About, Skills, Languages, Tools } from '../components';


const Web = () => {
  return (
    <Box>
      <MediaQuery maxWidth={576} >
        <Box sx={{ background: 'linear-gradient(180deg, #D3D3D3 0%, rgba(255, 255, 255, 0) 1.56%)' }} >
          <Information/>
          <Box sx={{ backgroundColor: '#545454', display:'flex', flexDirection:'column' }} >
            <About/>
            <Skills/>
            <Languages/>
            <Tools/>
          </Box>
          <Experience/>
          <Divider  />
          <Projects/>
          <Divider  />
          <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 14, padding: '15px 0px 15px 20px' }} >
            Developed by Luis Gabriel Millares 
          </Typography>
        </Box>
      </MediaQuery>

      {/* Medium Devices */}
      <MediaQuery minWidth={576} maxWidth={992}>
        <Box component="div" > 
            <Box sx={{ background: 'linear-gradient(151.73deg, #D3D3D3 0%, rgba(214, 214, 214, 0.429086) 15.34%, rgba(255, 255, 255, 0) 26.87%)' }}>
              <Information/>
              <Box sx={{ backgroundColor: '#545454', display:'flex' }} >
                <Box sx={{ flex: '50%' }} >
                  <About/>
                  <Skills/>
                </Box>
                <Box sx={{ flex: '50%' }}>
                  <Languages/>
                  <Tools/>
                </Box>
              </Box>
              <Experience/>
              <Divider  />
              <Projects/>
              <Divider  />
              <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 14, padding: '15px 0px 15px 20px' }} >
                Developed by Luis Gabriel Millares 
              </Typography>
            </Box>
        </Box>
      </MediaQuery>

      
      {/* Desktops */}
      <MediaQuery minWidth={992}>
        <Box component="div" sx={{ display:'flex',background: 'linear-gradient(151.73deg, #D3D3D3 0%, rgba(214, 214, 214, 0.429086) 15.34%, rgba(255, 255, 255, 0) 26.87%)' }}>
          <Box sx={{ flex: '75%'}} >
            <Information/>
            <Divider  />
            <Experience/>
            <Divider  />
            <Projects/>
            <Divider  />
            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 14, padding: '15px 0px 15px 20px'}} >
              Developed by Luis Gabriel Millares 
            </Typography>
          </Box>
          <Box sx={{ backgroundColor: '#545454', flex: '25%' }} >
            <About/>
            <Skills/>
            <Languages/>
            <Tools/>
          </Box>
        </Box>
      </MediaQuery>

    </Box>
    
  )
}

export default Web